import { TranslationMap } from '@trimble-gcs/i18n-types';

export function colorPickerTranslations() {
  return {
    colorPicker: {
      cancel: {
        text: $localize`:@@colorPicker.cancel:Cancel`,
        desc: 'Text for the button to cancel the color selection.',
      },
      ok: {
        text: $localize`:@@colorPicker.ok:OK`,
        desc: 'Text for the button to confirm the color selection.',
      },
    },
  } satisfies TranslationMap;
}
